import store from '../index';
import { sendPost } from '../../utils/request';
import * as type from '../constants/ActionTypes';

// banner列表
export const getBannerList = (data) => (
  sendPost('goods/show/queryShowAdvertisingWheel', data).then((res) => {
    if (res && res.code === type.OK && res.body) {
      store.dispatch({ payload: res.body, type: type.BANNER_LIST });
    }
    return res;
  })
);

// 分类列表
export const getCategoryList = (data) => (
  sendPost('category/findCategoriesByCity', data).then((res) => {
    if (res && res.code === type.OK && res.body) {
      store.dispatch({ payload: res.body, type: type.CATEGOYR_LIST });
    }
    return res;
  })
);

// 演出列表
export const getShowList = (data) => (
  sendPost('goods/show/findCategoryShowList', data).then((res) => {
    if (res && res.code === type.OK && res.body) {
      store.dispatch({ payload: res.body, type: type.SHOW_LIST });
    }
    return res;
  })
);

// 工会配置
export const getUnionConfig = (data) => (
  sendPost('/union/getunionconfig', data, true).then((res) => {
    if (res && res.code === type.OK && res.body) {
      store.dispatch({ payload: res.body, type: type.UNION_CONFIG });
    }
    return res;
  })
);

// 保存首页数据
export const saveHomeState = (data) => store.dispatch({ payload: data, type: type.SAVE_HOME_STATE });

// 清除首页数据
export const clearHomeState = () => store.dispatch({ type: type.CLEAR_HOME_STATE });
